import { AvailableLabel } from "@/types/v2";

/**
 * Whether `labelCatalog` has an entry matching `labelName`, for gating the
 * layout builder's bidirectional-sync toggle. When `labelCatalog` is
 * empty/undefined (Superpowers never synced, or a non-Tekmetric integrator
 * with no catalog concept at all), there is no catalog to judge against --
 * returns true (don't gate) rather than disabling every label for every
 * such shop.
 */
export function labelHasCatalogMatch(
  labelName: string,
  labelCatalog?: AvailableLabel[]
): boolean {
  if (!labelCatalog?.length) return true;
  return labelCatalog.some((entry) => entry.name === labelName);
}

/**
 * Whether `labelCatalog` has an entry matching `labelName` exactly --
 * used to gate renaming/deleting a label in Settings so a genuine
 * Tekmetric catalog entry isn't treated as a plain, locally-owned
 * string. Unlike `labelHasCatalogMatch`, an empty/undefined catalog
 * returns `false` here: with no catalog to check against, nothing can
 * be confirmed as "genuinely synced", so nothing should be locked.
 */
export function isLabelSyncedFromCatalog(
  labelName: string,
  labelCatalog?: AvailableLabel[]
): boolean {
  return !!labelCatalog?.some((entry) => entry.name === labelName);
}
